import React, { useEffect, useState } from "react";
import CommonTable from "../based/CommonTable";
import { INITPAGING, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import EmbroideryServices from "../based/services/EmbroideryServices";
import PatternUploadModal from "./components/PatternUploadModal";

function EmbroideryPatternList(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [isShowModal, setIsShowModal] = useState(false);
    const [selectId, setSelectId] = useState(0);

    useEffect(() => {
        _getData(paging);
    }, []);

    async function _getData(newPaging) {
        setIsBusy(true);
        let [err, data] = await EmbroideryServices.GetPatterns(newPaging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(newPaging);
        }
        setIsBusy(false);
    }

    function _handleDelete(id) {
        ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa họa tiết thêu này", () => {
            return new Promise(async (resolve, reject) => {
                let [err, data] = await EmbroideryServices.DeletePattern(id);
                if (!err && data) {
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                    _getData(paging);
                } else {
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                }
            });
        });
    }

    function _renderAction() {
        return (
            <button
                className="btn btn-custom my-2"
                onClick={() => {
                    setSelectId(0);
                    setIsShowModal(true);
                }}
            >
                <i className="fa fa-plus mr-2"></i>
                Thêm họa tiết thêu
            </button>
        );
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className="text-center">
                    <th>Tên</th>
                    <th>Hình</th>
                    <th>Hiệu ứng và kích thước</th>
                    <th>Tag</th>
                    <th>Hành động</th>
                </tr>
            </thead>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{item.name}</td>
                                <td className="text-center">{item.imageUrl ? <img src={item.imageUrl} alt={item.name} style={{ width: 60, height: 60, objectFit: "contain" }} /> : "-"}</td>
                                <td>
                                    {item.effects && item.effects.length > 0 ? (
                                        item.effects.map((effect, effectIdx) => (
                                            <div key={effectIdx}>
                                                {effect.name} ({effect.sizeCount || 0} size)
                                            </div>
                                        ))
                                    ) : (
                                        <span className="text-muted">-</span>
                                    )}
                                </td>
                                <td>
                                    {item.tags &&
                                        item.tags.map((tag, tagIdx) => (
                                            <span className="badge badge-secondary m-1" key={tagIdx}>
                                                {tag.tagName}
                                            </span>
                                        ))}
                                </td>
                                <td className="text-center">
                                    <button
                                        className="btn btn-custom m-1"
                                        onClick={() => {
                                            setSelectId(item.id);
                                            setIsShowModal(true);
                                        }}
                                    >
                                        Sửa
                                    </button>
                                    <button className="btn btn-danger m-1" onClick={() => _handleDelete(item.id)}>
                                        Xóa
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={5} className="text-center">
                            Không có dữ liệu
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    return (
        <React.Fragment>
            <Loading show={isBusy} msg="Đang tải dữ liệu..." />
            <CommonTable data={datas} paging={paging} hideSearch renderAction={_renderAction} renderHeader={_renderHeader} renderBody={_renderBody} onFilter={_getData} />
            {isShowModal && (
                <PatternUploadModal
                    id={selectId}
                    isShowModal={isShowModal}
                    onClose={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                    }}
                    saveSucceed={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                        _getData(paging);
                    }}
                />
            )}
        </React.Fragment>
    );
}

export default EmbroideryPatternList;
